<div class="container-fluid d-flex p-0">
    <app-side-bar></app-side-bar>
    <ng-container>
        <div style="padding: 15px; margin: 5px; width: -webkit-fill-available;">
            <div class="main-heading">
                <h1>Subscriber Mail Users Dashboard</h1>
            </div>

            <!-- Display Total Enabled Users and Today's Mail Sent Count -->
            <div class="summary">
                <p><strong>Total Enabled Users:</strong> {{ totalEnabledUsers }}</p>
                <p><strong>Today's Mail Sent Count:</strong> {{ mailSent }}</p>
            </div>

            <div class="card">
                <p-table #dt [value]="userData?.data" [paginator]="true" [rows]="10" [globalFilterFields]="['email']"
                    [loading]="loading">
                    <ng-template pTemplate="caption">
                        <div class="flex" style="display: flex; justify-content: flex-end; gap: 10px;">
                            <span class="p-input-icon-left ml-auto">
                                <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                                    placeholder="Search by Email" />
                            </span>
                        </div>
                    </ng-template>
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Email</th>
                            <th>Last Mail Date</th>
                            <th>Last Mail Time</th>
                            <th>User Status</th>
                            <th>Last Mail Status</th>
                            <th>Actions</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-user>
                        <tr>
                            <td>{{ user.email }}</td>
                            <td>{{ user.lastmaildate || 'N/A' }}</td>
                            <td>{{ user.lastmailtime || 'N/A' }}</td>
                            <td>
                                <!-- Only show dots for status -->
                                <span class="status-indicator"
                                    [ngClass]="{'green-dot': user.userstatus, 'red-dot': !user.userstatus}"></span>
                            </td>
                            <td>
                                <span class="status-indicator"
                                    [ngClass]="{'green-dot': user.lastmailstatus, 'red-dot': !user.lastmailstatus}"></span>
                            </td>
                            <td>
                                <button pButton type="button" icon="pi pi-trash" class="p-button-danger"
                                    (click)="confirmDelete(user.email)"></button>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
            <p-dialog [(visible)]="showDeleteDialog" header="Confirm Delete" [modal]="true" [closable]="false"
                [dismissableMask]="false" [style]="{ width: '400px' }">
                <p>Are you sure you want to delete this user?</p>
                <p-footer>
                    <button pButton type="button" label="No" icon="pi pi-times"
                        (click)="showDeleteDialog = false"></button>
                    <button pButton type="button" label="Yes" icon="pi pi-check" (click)="deleteUser()"></button>
                </p-footer>
            </p-dialog>
        </div>
    </ng-container>
</div>